/** @jsx jsx */
import React, { useEffect, useRef } from 'react';
import objectFitImages from 'object-fit-images';

import { jsx } from '@emotion/react';

import { getImageSizes } from '../../services/getImageSizes';
import { getImageSrcset } from '../../services/getImageSrcset';
import { getResponsiveImage } from '../../services/getResponsiveImage';

interface ResponsiveImageProps {
    image: string;
    className?: string;
    objectFit?: boolean;
    style?: any;
}

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
    image,
    className,
    objectFit = false,
    ...rest
}) => {
    if (!image) return null;

    const imageUrl = image.replace('http:', '').replace('https:', '');

    if (imageUrl.includes('.svg')) {
        return <img src={imageUrl} className={className} {...rest} />;
    }

    const imgRef = useRef(null);
    const imageSrcsetWebp = getImageSrcset(imageUrl, 'webp');
    const imageSrcset = getImageSrcset(imageUrl);

    useEffect(() => {
        if (imgRef.current) {
            objectFitImages(imgRef.current);
        }
    }, [imgRef]);

    return (
        <picture className={className}>
            <source
                type="image/webp"
                srcSet={imageSrcsetWebp}
                sizes={getImageSizes()}
            />
            <source srcSet={imageSrcset} sizes={getImageSizes()} />
            <img
                src={getResponsiveImage(image, 'mobile')}
                {...(objectFit && { ref: imgRef })}
                {...rest}
            />
        </picture>
    );
};
